import { Button, Text, Title2, makeStyles } from '@fluentui/react-components';
import { tokens } from '@vigeo/ui';
import { LOGOUT_URL } from '@/lib/auth';

const useStyles = makeStyles({
  page: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalL,
    maxWidth: '32rem',
    marginInline: 'auto',
    paddingBlock: tokens.spacingVerticalXXXL,
    paddingInline: tokens.spacingHorizontalL,
  },
  actions: {
    display: 'flex',
    gap: tokens.spacingHorizontalM,
  },
});

/**
 * Signed in, but without an HR role. Says what to do next rather than just
 * refusing — the fix is an Entra role assignment, which the person cannot do
 * themselves.
 */
export function NoAccessPage() {
  const styles = useStyles();

  return (
    <div className={styles.page}>
      <Title2>You do not have access</Title2>
      <Text>
        Your Vigeo account is signed in, but it has not been granted access to the HR
        dashboard. Ask an administrator to assign you the HR Admin or HR Viewer role, then
        sign in again.
      </Text>
      <div className={styles.actions}>
        <Button as="a" href={LOGOUT_URL}>
          Sign out
        </Button>
      </div>
    </div>
  );
}
